import { useQuery, UseQueryOptions } from 'react-query'

import { CacheKeys } from '../../helpers/cacheKeys'
import { getLMSUserLoginUrl } from '../../models/user'

export const useLMSLoginUrl = (
  userId: string,
  { enabled = true, refetchOnMount = 'always' }: UseQueryOptions = {}
) => {
  const { data, isLoading, isFetching, refetch } = useQuery(
    `${CacheKeys.LMS_LOGIN_URL}-${userId}`,
    () => getLMSUserLoginUrl(userId),
    {
      enabled,
      refetchOnMount,
      refetchOnWindowFocus: false,
      retry: true,
      retryDelay: (attempt) => Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 30 * 1000),
    }
  )

  return { lmsLoginUrl: data, isLoading, isFetching, refetch }
}
